<template>
  <v-card class="d-flex flex-column justify-space-between">
    <v-card-text>
      <single-user-plan-description v-if="isSingleUser" />
      <small-business-plan-description v-if="isSmallBusiness" />
      <medium-business-plan-description v-if="isMediumBusiness" />
      <premium-business-plan-description v-if="isPremiumBusiness" />
    </v-card-text>
    <v-card-actions class="d-flex justify-space-around">
      <v-btn
        v-for="price in prices"
        :key="price.id"
        :disabled="disabled"
        color="primary"
        @click="selectPrice(price)"
      >
        {{ formattedPrice(price) }} per {{ price.interval }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import MediumBusinessPlanDescription from './MediumBusinessPlanDescription.vue'
import PremiumBusinessPlanDescription from './PremiumBusinessPlanDescription.vue'
import SingleUserPlanDescription from './SingleUserPlanDescription.vue'
import SmallBusinessPlanDescription from './SmallBusinessPlanDescription.vue'
import sortBy from 'lodash/sortBy'
import { formatAsCurrency } from '@/utils/localeFormat'

export default {
  name: 'AvailableSubscriptionPlan',
  components: {
    SmallBusinessPlanDescription,
    SingleUserPlanDescription,
    MediumBusinessPlanDescription,
    PremiumBusinessPlanDescription
  },
  props: {
    subscriptionPlan: { type: Object, required: true },
    disabled: { type: Boolean, required: true }
  },
  data() {
    return {}
  },
  computed: {
    prices() {
      return sortBy(
        this.getActivePricesForProduct(this.subscriptionPlan.id),
        'interval'
      )
    },
    planIdentifier() {
      return this.subscriptionPlan.role
    },
    isSingleUser() {
      return this.planIs('singleUser')
    },
    isSmallBusiness() {
      return this.planIs('smallBusiness')
    },
    isMediumBusiness() {
      return this.planIs('mediumBusiness')
    },
    isPremiumBusiness() {
      return this.planIs('premiumBusiness')
    }
  },
  beforeCreate() {
    this.dispatchActions(['get_activePrices']).then(
      () => (this.loading = false)
    )
    this.mapGetters(['getActivePricesForProduct'])
  },
  methods: {
    formattedPrice({ unit_amount: amountInCents, currency }) {
      return formatAsCurrency({ amountInCents, currency })
    },
    async selectPrice(price) {
      this.$emit('priceSelected', price)
    },
    planIs(planIdentifier) {
      return this.planIdentifier === planIdentifier
    }
  }
}
</script>
